import React from "react";

function Application(props) {
  var previewImage = props.previewImage;
  return (
    <div className="application">
      <div class="heading row">
        <a target="_blank" rel="noopener noreferrer" href={props.url}>
          {props.name}
        </a>
      </div>
      <div class="content row">
        <div
          class="col-sm col-md-6"
          dangerouslySetInnerHTML={{ __html: props.description }}
        ></div>
        <div class="col-sm col-md-6">
          <img src={require(`${previewImage}`)} alt="screenshot" />
        </div>
      </div>
    </div>
  );
}

export default Application;
